module.exports = __webpack_public_path__ + "media/images/color_picker-6e534ba3.png";